import { AfterViewInit, Directive, ElementRef, inject, Input } from '@angular/core';

import { SsrService } from '@services/ssr.service';

@Directive({
  selector: '[app-preload-image]'
})
export class PreloadImageDirective implements AfterViewInit {
  private el = inject(ElementRef);
  private ssrService = inject(SsrService);
  @Input('app-preload-image') parent?: string;
  @Input('ngSrc') ngSrc?: string;
  @Input() priority?: boolean;

  ngAfterViewInit(): void {
    if (this.ssrService.isServer() || !this.parent) return;
    const parent = this.el.nativeElement.closest(this.parent);
    if (!parent) return;
    const parentWidth = parent.getBoundingClientRect().width;
    if (!parentWidth) return;
    const imageWidth = parentWidth;
    const obs = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        if (this.ngSrc) this.el.nativeElement.setAttribute('ngSrc', this.ngSrc);
        if (this.priority) this.el.nativeElement.setAttribute('priority', '');
        this.el.nativeElement.setAttribute('loading', 'eager');
        console.log('Preloading image:', this.el.nativeElement.src);
        obs.disconnect();
      }
    }, {
      root: parent,
      rootMargin: '0px ' + (imageWidth * 2.01) + 'px',
      threshold: 0.1,
    });
    obs.observe(this.el.nativeElement);
  }
}